
import { Collapse } from 'bootstrap';

const filterWrapperId = 'articleFilters';

// Filter select
const categorySelects = document.querySelectorAll('.pane--cards__filter-wrapper__filters select');
if (categorySelects) {
    const url = new URL(window.location.href);

    categorySelects.forEach((select) => {
        select.addEventListener('change', (event) => {
            select.disabled = true;

            url.searchParams.delete('page');

            if (event.target.value === 'remove') {
                url.searchParams.delete(`category_${event.target.dataset.level ?? 0}`);
            } else {
                url.searchParams.set(`category_${event.target.dataset.level ?? 0}`, event.target.value);
            }

            url.hash = 'pane-cards-wrapper';

            if (event.target.dataset.level === '0') {
                url.searchParams.delete(`category_1`);
                url.searchParams.delete(`category_2`);
            }

            window.location.href = url.href;
        });
    });

    const filterCollapse = document.getElementById(filterWrapperId);
    if (filterCollapse) {
        const bootstrapCollapse = new Collapse(filterCollapse, {toggle: false});

        if (window.screen.width > 991 || categorySelects && categorySelects[0].value) {
            bootstrapCollapse.show();
        }
    }
}
